import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import AbortIcon from '@material-ui/icons/Stop';
import {
  HISTORY_JOBS_TYPE,
} from '../../ComponentTypes';
import './JobsHeaderButtons.scss';

export default ({ jobType }) => {
  const JobsHeaderButtons = ({ checked, onAbort, jobService }) => {
    const handleAbort = () => {
      onAbort(checked.map(n => n.obj));
    };
    const canAbort = Boolean(checked.length && !!checked.find(n => jobService.jobStatusAbortable(n.obj)));
    return (
      <React.Fragment>
        <Tooltip title="Stop checked job(s)">
          <div>
            {/* div to avoid material-ui warning about having a tooltip on an inactive button */}
            {(jobType !== HISTORY_JOBS_TYPE) && (
              <Button variant="outlined" aria-label="Abort" disabled={!canAbort} onClick={handleAbort} id="grb-abort-btn">
                <AbortIcon />
                Abort
              </Button>
            )}
          </div>
        </Tooltip>
      </React.Fragment>
    );
  };

  JobsHeaderButtons.propTypes = {
    onAbort: PropTypes.func.isRequired,
    checked: PropTypes.arrayOf(PropTypes.shape({})),
    jobService: PropTypes.shape({
      jobStatusAbortable: PropTypes.func,
    }).isRequired,
  };

  JobsHeaderButtons.defaultProps = {
    checked: [],
  };

  return JobsHeaderButtons;
};
